import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PastOrder from "../containers/Profile/Order/Order";
import CurrentOrder from "../containers/Profile/Order/CurrentOrder";
import CartPopUp from "../containers/Cart/CartPopUp";
import {useCart} from "../contexts/cart/use-cart";
import {
  PageWrapper,
  SidebarSection,
} from "../containers/Profile/Profile.style";
import { Modal } from "@redq/reuse-modal";
import { Tab, Tabs, Spinner, Modal as BModal } from "react-bootstrap";
import { useDeviceType } from "../helper/useDeviceType";
import { connect } from "react-redux";
import {
  currentOrders,
  pastOrders,
  fetchParticularOrder,
  reOrder,
  resetreordersuccess
} from "../store/actions/userAction";
import "./all-order.css";
import t from '../i18n/translate';
import { initBasket } from "../store/actions/cartAction";
import RED_API from "../network/redAPI";
import { Dialog, DialogActions, DialogTitle, Divider, Button as MButton, makeStyles } from "@material-ui/core";
import { logPurchase, logPurchaseOnOnlinePayment } from "../services/googleAnalytics";

const useStyles = makeStyles({
  dialog: {
    position: 'absolute',
    right: window.innerWidth > 768 ? 40 : 0,
    top: window.innerWidth > 768 ? 0 : 70,
  },
});

const AllOrderPage = (props, { userAgent }) => {
  const deviceType = useDeviceType(userAgent);
  const [active, setActive] = useState("currentOrder");
  const { fetchOrderItems, cartclose } = useCart();
  const isExpress = localStorage.getItem('expressMode') ? 'express' : 'normal';

  const history = useHistory()
  const classes = useStyles();

  const [showDialog, setShowDialog] = useState(false);
  const [showWaitingModal, setShowWaitingModal] = useState(false);

  const [listPaymentMethod, setListPaymentMethod] = useState([]);
	const user = localStorage.getItem("user");

	const checkUserAuth = () => {
		if (!user) return false;
		else return true
	}
	useEffect(() => {
		sessionStorage.setItem("pageSource", "/all-orders")
		if (!user) {
			history.push("/")
		}
	}, []);
  const handleSaveCard = async() => {
    await RED_API.EnableVisaToken(1)
      .then(res => res.json())
      .then((res) => {
        if (res.success) {
          setShowDialog(false);
          history.replace("/all-orders", null, null);
          sessionStorage.removeItem("is_new_visa_card");
          window.location.reload();
        }
      }).catch((error) => {
        console.error(error);
      });
  }

  const handleCloseDialog = () => {
    setShowDialog(false);

    let timeout = setTimeout(() => {
      history.replace("/all-orders", null, null);
      sessionStorage.removeItem("is_new_visa_card");
      window.location.reload();
    }, 1000)

    return () => clearTimeout(timeout);

  }

	const orderData = localStorage.getItem('order_data')
  // check save visa card
  const status = sessionStorage.getItem("is_new_visa_card");
  useEffect(() => {
    if(status == 1){
      setShowDialog(true);
    }else{
      setShowDialog(false);
      sessionStorage.removeItem("is_new_visa_card");
    }
  },[]);

  // useEffect(async () => {
  //   if (window.location.search !== "") {
  //     await RED_API.GetNewVisaToken()
  //       .then(res => res.json())
  //       .then((res) => {
  //         if (res.success) {
  //           if (res.data.is_new === 1) {
  //             setShowDialog(true);
  //           } else {
  //             setShowWaitingModal(true);
  //             let reload = setTimeout(() => {
  //               history.replace("/all-orders", null, null);
  //               setShowWaitingModal(false);
  //               localStorage.removeItem('order_data')
  //               window.location.reload();
  //             }, 3000);
              
  //             return () => clearTimeout(reload);
  //           }
  //         }
  //       });
  //   }
  // }, []);

  useEffect(async () => {

	  if (user) {
		  try {
			  await RED_API.PaymentGateWay({
				  service: "webpay.acquire.getpaymentmethods",
			  })
				  .then((res) => res.json())
				  .then((res) => {
					  setListPaymentMethod(res.data.data);
				  });
		  } catch (error) {
			  alert(error.message)
		  }
    }
  }, []);

  useEffect(() => {
	  if (user) {
		  props.initBasket(isExpress);
		  fetchOrderItems(isExpress);
	  }
  }, []);

  useEffect(() => {
    if (window.scrollY < 200) return;

    let scrollToTop = setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 350);

    return () => clearTimeout(scrollToTop);
  }, []);

  useEffect(() => {
    window.addEventListener("pageshow", function (evt) {
      if (evt.persisted) {
        setTimeout(function () {
          window.location.reload();
        }, 3000);
      }
    }, false);
  }, []);

  // useEffect(() => {
  //   if (window.location.search !== "") {
  //     setShowWaitingModal(true);
      
  //     let reload = setTimeout(() => {
  //       history.replace("/all-orders", null, null);
  //       setShowWaitingModal(false);
  //       window.location.reload();
  //       // history.push("/all-orders");
  //     }, 3000);

  //     return () => clearTimeout(reload);
  //   }
  //   return;

  // }, []);

  useEffect(() => {
	  if (user) {
		  const lang = localStorage.getItem('lang') || 'en';
		  const notificationID = localStorage.getItem('notificationID');

		  if (!notificationID) return;
		  RED_API.FetchParticularOrder({order_id: parseInt(notificationID), lang})
			  .then((res) => res.json())
			  .then(res => {
				  if (res.success) {
					  if ([6, 7].includes(res.data.status)) {
						  setActive("pastOrder");
					  } else {
						  setActive("currentOrder");
					  }
				  }
			  });
	  }
  }, []);

  window.onbeforeunload = () => {cartclose()};

  return (
    <>
      {
        showWaitingModal &&
        <div
          style={{
          position: "absolute",
          inset: "0",
          height: "100vh",
          display: "grid",
          placeItems: "center",
          zIndex: "998",
          backgroundColor: "rgba(0, 0, 0, 0.25)"
        }}>
          <Spinner  animation="border" style={{zIndex: "999", width: "80px", height: "80px", color:`${props.cartType === "express" ? "#e83e8c" : "#9cc54b" }`}} />
        </div>
      }
      <Modal>
        <PageWrapper>
          <Tabs
            id="controlled-tab-example"
            activeKey={active}
            onSelect={(k) => setActive(k)}
          >
            <Tab eventKey={"currentOrder"} title={ t('shop_order_list_screen_current_order_tab', false) }>
              <CurrentOrder
                deviceType={deviceType}
                props={props}
                currentorders={props.current_orders}
                currentorderDetails={props.fetch_particular_order}
                tabactive={active}
                listPaymentMethod={listPaymentMethod}
              />
            </Tab>
            <Tab eventKey={"pastOrder"} title={ t('shop_order_list_screen_past_order_tab', false) }>
              <PastOrder
                deviceType={deviceType}
                props={props}
                pastorders={props.past_orders}
                pastorderDetails={props.fetch_particular_order}
                tabactive={active}
                listPaymentMethod={listPaymentMethod}
              />
            </Tab>
          </Tabs>
        </PageWrapper>
      </Modal>
      <CartPopUp deviceType={deviceType} />

      <Dialog
        open={showDialog}
        onClose={handleCloseDialog}
        aria-labelledby="responsive-dialog-title"
        classes={{
          paper: classes.dialog
        }}
      >
        <DialogTitle id="responsive-dialog-title">{ t('shop_order_list_save_card_alert') }</DialogTitle>
        <Divider/>
        <DialogActions>
          <MButton
            variant="contained"
            style={{ textTransform: 'capitalize', background: '#343a40', color: '#ffffff'  }}
            onClick={handleCloseDialog}
          >
            { t("shop_order_list_cancel_label") }
          </MButton>
          <MButton
            variant="contained"
            style={{ textTransform: 'capitalize' }}
            onClick={handleSaveCard}
          >
            { t("shop_order_list_save_label") }
          </MButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
AllOrderPage.getInitialProps = async (appContext) => {
  const { req } = appContext.ctx;
  const userAgent = req ? req.headers["user-agent"] : navigator.userAgent;
  return { userAgent };
};
const mapStateToProps = (state) => {
  return {
    success: state.authReducer.success,
    modalData: state.productReducer.modalData,
    user_address: state.userReducer.address,
    past_orders: state.userReducer.past_orders,
    current_orders: state.userReducer.current_orders,
    fetch_particular_order: state.userReducer.fetch_particular_order,
    reordersuccess: state.userReducer.reordersuccess,
    cartType: state.cartReducer.cartType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    currentOrders: (data) => currentOrders(data, dispatch),
    pastOrders: (data) => pastOrders(data, dispatch),
    fetchParticularOrder: (data) => fetchParticularOrder(data, dispatch),
    reOrder: (data) => reOrder(data, dispatch),
    resetreordersuccess: () => resetreordersuccess(dispatch),
    initBasket: (data) => initBasket(data, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AllOrderPage);
